const getMessages = state => state.lead.seekerChat.messages;
const getGroupMessages = state => state.lead.seekerChat.groupMessages;
const getMessageLoading = state => state.lead.seekerChat.loading;
const getLeadName = state => state.lead.seekerChat.leadName;
const getUploadFiles = state => state.lead.seekerChat.filesToUpload;
const getUploadLoading = state => state.lead.seekerChat.fileLoading;
const getSnackBar = state => state.lead.seekerChat.snackBarAdjuntos;
const getShowmodal = state => state.lead.seekerChat.showModal;

export {
  getMessages,
  getGroupMessages,
  getMessageLoading,
  getLeadName,
  getUploadFiles,
  getUploadLoading,
  getSnackBar,
  getShowmodal
};
